import * as Yup from "yup";

export const schema = Yup.object().shape({
  name: Yup.string().required("Ingresa el nombre de tu Co-hort."),
  startDate: Yup.string().when("type", {
    is: "SYNCHRONOUS",
    then: Yup.string().required("Ingresa la fecha de inicio."),
  }),
  classes: Yup.number().min(1).required("Se requieren numero de clases"),
  private: Yup.boolean().required("Se requiere acceso"),
  type: Yup.string().required("Se requiere un tipo"),
  endDate: Yup.string()
    .nullable()
    .when("type", {
      is: "SYNCHRONOUS",
      then: Yup.string().required("Ingresa una fecha de fin."),
    }),
  abilitiesIds: Yup.array()
    .required("Selecciona una habilidad.")
    .min(1, "Poner al menos una habilidad")
    .max(1, "Solo puede asignar una habilidad"),
  tags: Yup.array(),
  mentorsIds: Yup.array().of(Yup.string()).nullable(),
  hidden: Yup.bool().required(),
  eventsIds: Yup.array().of(Yup.string()).nullable(),
  maxStage: Yup.number().min(1).required(),
});

interface FormValues {
  name: string;
  abilitiesIds: any[];
  type: string;
  classes: number;
  mentorsIds: string[];
  private: boolean;
  startDate: string;
  endDate: string;
  hidden: boolean;
  tags: string[];
  eventsIds: string[];
  maxStage: number;
}

export const initialValues: FormValues = {
  name: "",
  classes: 1,
  startDate: "",
  endDate: "",
  private: false,
  hidden: false,
  abilitiesIds: [],
  mentorsIds: [],
  type: "",
  tags: [],
  eventsIds: [],
  maxStage: 1,
};
